export default __webpack_public_path__ + "static/media/ReportDownload.47a4140a.svg";